<div class="moving">
  <layer-header
    (closeLayer)="closeLayer()"
    [listToggle]="false"
    [listIcons]="false"
    [title]="'Add Status'"
  >
    <ng-content></ng-content>
  </layer-header>
  <div class="row">
    <div class="col-12">
      <div class="row mb-3">
        <div class="col-md-12 col-xl-8">
          <label class="input-label field-required">{{
            'roles.name' | translate
          }}</label>
          <input
            type="text"
            name="name"
            [(ngModel)]="roleStatus.name"
            #name="ngModel"
            required
            class="form-control"
          />
        </div>
        <div class="col-md-12 col-xl-4">
          <label class="input-label">{{ 'roles.number' | translate }}</label>
          <input
            [(ngModel)]="roleStatus.sortNumber"
            name="number"
            type="number"
            class="form-control"
          />
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <label class="input-label">{{
            'roles.destination' | translate
          }}</label>
          <ng-select
                  bindLabel="text"
                  bindValue="id"
                  [items]="allRoles"
                  [clearable]="false"
                  [multiple]="true"
                  (add)="selected($event)"
                  (remove)="removed($event)"
          ></ng-select>
        </div>
      </div>
      <div class="row">
        <div class="col-12 mt-4 mb-4">
          <primary-text-button
            (onClick)="createRoleFileValidatedStatus(role.id)"
            [disabled]="isLoading || (name && name.invalid)"
          >
            {{ 'Add a status' | translate }}
          </primary-text-button>
        </div>
      </div>
    </div>
  </div>
</div>
